export function parseTags(tagsString) {
  if (!tagsString) return [];
  return tagsString.split(',').map(t => t.trim()).filter(Boolean);
}

export function serializeTags(tags) {
  return tags.join(', ');
}
